import { render, staticRenderFns } from "./SideMenu-inner-bv.vue?vue&type=template&id=1c39f0e4&"
import script from "./SideMenu-inner-bv.vue?vue&type=script&lang=js&"
export * from "./SideMenu-inner-bv.vue?vue&type=script&lang=js&"
import style0 from "./SideMenu-inner-bv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports